import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    NgbCarouselModule,
    NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FadeInOnScrollModule } from '../directives/fade-in-on-scroll/fade-in-on-scroll.module';
import { ProductCardComponent } from './product-card/product-card.component';
import { SimpleCountryCardComponent } from './simple-country-card/simple-country-card.component';
import { PrimaryButtonComponent } from './primary-button/primary-button.component';
import { ComprehensiveServiceComponent } from './comprehensive-service/comprehensive-service.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { BlogCardComponent } from './blog-card/blog-card.component';
import { ImageCollageComponent } from './image-collage/image-collage.component';
import { TripAdvisorCardComponent } from './trip-advisor-card/trip-advisor-card.component';
import { ProductsCarouselComponent } from './products-carousel/products-carousel.component';
import { ImageVisorComponent } from './image-visor/image-visor.component';
import { register } from 'swiper/element/bundle';
register();
import { AccordionComponent } from './accordion/accordion.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { BgPrimaryTextComponent } from './bg-primary-text/bg-primary-text.component';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductsGridComponent } from './products-grid/products-grid.component';
import { HeroHomeComponent } from './hero-home/hero-home.component';
import { FormJoinNewsletterComponent } from './form-join-newsletter/form-join-newsletter.component';
import { HugeProductCarouselComponent } from './huge-product-carousel/huge-product-carousel.component';
import { SearchFiltersComponent } from './search-filters/search-filters.component';
import { BigProductCardComponent } from './big-product-card/big-product-card.component';
import { WhatsappBtnComponent } from './whatsapp-btn/whatsapp-btn.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LoadSpinnerComponent } from './load-spinner/load-spinner.component';
import { InputSearchComponent } from './input-search/input-search.component';
import { ProductLinkPipe } from '../pipes/product-link.pipe';
import { ToAvifPipe } from '../pipes/to-avif.pipe';
import { GenericSpinnerComponent } from './generic-spinner/generic-spinner.component';
import { ScrollButtonsComponent } from './scroll-buttons/scroll-buttons.component';

const components = [
    ProductCardComponent,
    SimpleCountryCardComponent,
    PrimaryButtonComponent,
    ComprehensiveServiceComponent,
    SuggestionComponent,
    BlogCardComponent,
    ImageCollageComponent,
    TripAdvisorCardComponent,
    ImageVisorComponent,
    ImageVisorComponent,
    AccordionComponent,
    ContactFormComponent,
    ProductsCarouselComponent,
    BgPrimaryTextComponent,
    ProductsListComponent,
    ProductsGridComponent,
    HugeProductCarouselComponent,
    HeroHomeComponent,
    FormJoinNewsletterComponent,
    SearchFiltersComponent,
    BigProductCardComponent,
    WhatsappBtnComponent,
    NotFoundComponent,
    LoadSpinnerComponent,
    InputSearchComponent,
    ProductLinkPipe,
    ToAvifPipe,
    GenericSpinnerComponent,
    ScrollButtonsComponent,
];

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbCarouselModule,
        NgbDatepickerModule,
        RouterModule,
        FadeInOnScrollModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [...components],
})
export class ComponentsModule {}
